import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Heart: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={54}
    viewBox="0 0 66 54"
    fill="none"
    {...props}
  >
    <g>
      <ellipse
        cx="23.5294"
        cy="28.504"
        rx="19.5392"
        ry="19.5392"
        fill="white"
      />
      <path
        d="M10.008 30.0239C4.48072 24.4967 4.48073 15.5352 10.008 10.008C15.5352 4.48072 24.4967 4.48072 30.0239 10.008L52.7902 32.7742L32.7742 52.7902L10.008 30.0239Z"
        fill="#002677"
      />
      <path
        d="M35.9759 10.5394C41.5032 5.01215 50.4646 5.01215 55.9919 10.5394C61.5191 16.0667 61.5191 25.0281 55.9919 30.5554L33.2256 53.3216L13.2097 33.3056L35.9759 10.5394Z"
        fill="#FF612B"
      />
    </g>
  </Box>
)

export default Heart
